import { useSelector } from 'react-redux';

export const useHasPrivilege = () => {
  const permissions = useSelector((state) => state.auth.permissions || []);
  return (privilege) => permissions.includes(privilege);
};

export const useHasAdminAccess = () => {
  const permissions = useSelector((state) => state.auth.permissions || []);
  return permissions.some((privilege) => privilege.startsWith("MANAGE:"));
};
